import {useIntl} from 'react-intl'
import React, { useState, useEffect } from 'react';
import axios, {AxiosResponse} from 'axios'

import {PageTitle} from '../../../_metronic/layout/core'
import {
  ListsWidget5,
  MixedWidget10,
  MixedWidget11,
  MixedWidget2,
  StatisticsWidget5,
  ChartsWidget5,
} from '../../../_metronic/partials/widgets'
import {Field, useFormik} from 'formik'
import { log } from 'console';
// import {getExpenses} from '../dashboard/'

const DashboardPage = () => {
  const [startDate, setStartDate] = useState<string | null>(formatDate(new Date()))
  const [endDate, setEndDate] = useState<string | null>(formatDate(new Date()))
  const cardColors = ['primary', 'success', 'warning', 'danger']; // Define the list of colors to cycle through
  const [dashboardDataUser, setDashboardDataUser] = useState<any>([]); // Assume this will hold an array of users
  const [user, setUser] = useState(null)
  // const [dashboardData, setDashboardData] =useState<any>(null);; // Adjust type according to your data
  // Set default dashboard data
  const [dashboardData, setDashboardData] = useState<any>({
    balance_due: '0',
    collected: '0',
    expeness: '0',
    member_expired: '0',
    members: '0',
    newlead: '0',
    renew_subscription: '0',
    sale: '0',
    daily_spa: '0',
  });
  
  function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  // Add state for filter type (daily, monthly, yearly)
  const [filterType, setFilterType] = useState<string>('daily');

  // Fetch data when the component mounts or when filterType changes
  useEffect(() => {
    const fetchData = async () => {
      await fetchAllBillings();
    };

    fetchData();
  }, [filterType]); // Depend on filterType
  useEffect(() => {
    // Get user data from localStorage
    const userData = localStorage.getItem('userData')
    if (userData) {
      setUser(JSON.parse(userData)) // Parse JSON string into an object
    }
    console.log('iooooo');
    
    console.log(userData);
    

  }, [])
  
  // Function to fetch dashboard data
  async function fetchAllBillings() {
    console.log('Fetching dashboard data...');
    try {
      const API_URL = process.env.REACT_APP_THEME_API_URL;

      const response = await axios.get(`${API_URL}/dashboard`, {
        params: {
          // type: filterType, // Send the filter type as a query parameter
          start_date: startDate, 
          end_date: endDate ,
          auth_user_id:localStorage.getItem('auth_user_id')
        },
      });

      const dashboardData = response.data.data as any;
      const users = response.data.data.users ?? [];
      const { balance_due, collected, expeness,member_expired,members,newlead,renew_subscription,sale,daily_spa} = dashboardData as any;
      setDashboardDataUser(users);
      setDashboardData({ balance_due, collected, expeness,member_expired,members,newlead,renew_subscription,sale,daily_spa });
        console.log('data log' + dashboardData['balance_due']);
        

      console.log('Dashboard data:', dashboardData);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  }
   // Handle form submit on "View Customer" button click
   const handleViewCustomer = (e: React.FormEvent) => {
    e.preventDefault();
    fetchAllBillings(); // Fetch dashboard data with the selected date range
  };

  return (
  <>

  {/* begin::Row */}
  <div className='row p-2'>
      <div className='col-lg-8'>
      {/* <form id='kt_modal_add_user_form' className='form' onSubmit={formik.handleSubmit} noValidate> */}
      <form className='form' onSubmit={handleViewCustomer}>
          <div className='row'>
          <div className="col-xl-4">
          <input
                  type="date"
                  className='form-control form-control-solid mb-3 bg-white'
                  name="startDate"
                  value={String(startDate)}
                  onChange={(e) => setStartDate(e.target.value)} // Update startDate when changed
                />
          </div>
          <div className="col-xl-4">
                
                <input
                  type="date"
                  className='form-control form-control-solid mb-3 bg-white'
                  name="endDate"
                  value={String(endDate)}
                  onChange={(e) => setEndDate(e.target.value)} // Update endDate when changed
                />
          </div>
          <div className="col-xl-4">
                <button
                    type='submit'
                    className='btn btn-primary btn-sm'
                  >
                  <span className='indicator-label'>View Details</span>
                </button>
          </div>
          </div>
        </form>
      </div>
        {/* <div className='col-lg-4'>

        </div> */}
      <div className='col-lg-4 '>
        {/* <select 
          className='form-select' 
          value={filterType} 
          onChange={(e) => setFilterType(e.target.value)}
        >
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
        </select> */}
      </div>
    </div>
  <div className='row gy-5 g-xl-8'>

      <div className='col-xxl-3 col-md-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'primary'
          svgIcon= 'people'
          iconColor= 'white'
          title= {dashboardData['members'] ?? '0'}
          titleColor= 'white'
          description= 'Client'
          descriptionColor= 'white'
        />
      </div>
      <div className='col-xxl-3 col-md-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'success'
          svgIcon= 'airplane'
          iconColor= 'white'
          title= {dashboardData['newlead']}
          titleColor= 'white'
          description= 'Daily Customers'
          descriptionColor= 'white'
        />
      </div>
      <div className='col-xxl-3 col-md-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'warning'
          svgIcon= 'bill'
          iconColor= 'white'
          title= {dashboardData['daily_spa']}
          titleColor= 'white'
          description= 'Daily SPA '
          descriptionColor= 'white'
        />
      </div>
      <div className='col-xxl-3 col-md-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'danger'
          svgIcon= 'crown-2'
          iconColor= 'white'
          title= {dashboardData['member_expired']}
          titleColor= 'white'
          description= 'Expired Membership'
          descriptionColor= 'white'
        />
      </div>
      <div className='row gy-5 g-xl-8'>
        {dashboardDataUser.map((user: any, index: number) => (
          <div key={user.id} className='col-xxl-3 col-md-3'>
            <a href='#' className={`card bg-${cardColors[index % cardColors.length]} hoverable mb-2`}>
              <div className='card-body p-2'>
                <div className='fw-semibold fw-bold fs-2 text-white'> {user.name}</div>
                <div className='badge badge-light-success fw-bolder me-auto px-4 py-3'>{user.role_name}</div>
                <div className='row'>
                  <div className='col-8 fw-semibold text-white'>Client</div>
                  <div className='col-4 text-white fw-bold fs-2 mb-2'>{user.members_created}</div>
                </div>
                <div className='row'>
                  <div className='col-8 fw-semibold text-white'>Daily Customer</div>
                  <div className='col-4 text-white fw-bold fs-2 mb-2'>{user.daily_customer}</div>
                </div>
                <div className='row'>
                  <div className='col-8 fw-semibold text-white'>Daily SPA Customer</div>
                  <div className='col-4 text-white fw-bold fs-2 mb-2'>{user.daily_spa_customer}</div>
                </div>
                <div className='row'>
                  <div className='col-8 fw-semibold text-white'>Expenses </div>
                  <div className='col-4 text-white fw-bold fs-2 mb-2'>{user.expireMember}</div>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>

      {/* <div className='col-xxl-3 col-md-3'>
       
          <a href='#' className={`card bg-primary hoverable mb-2`}>
            <div className='card-body p-2'>
            <div className={`fw-semibold text-white`}>User Name</div>
            <div className={`text- fw-bold fs-2 mb-2 `}>{dashboardData['newlead']}</div>
              <div className='row'>
                <div className={`col-lg-8 fw-semibold text-white`}>Members</div>
                <div className={` col-lg-4 text- fw-bold fs-2 mb-2 `}>{dashboardData['newlead']}</div>
              </div>
              <div className='row'>
                <div className={`col-lg-8 fw-semibold text-white`}>Daily Customer</div>
                <div className={` col-lg-4 text- fw-bold fs-2 mb-2 `}>{dashboardData['newlead']}</div>
              </div>
              <div className='row'>
                <div className={`col-lg-8 fw-semibold text-white`}>Daily SPA Customer</div>
                <div className={` col-lg-4 text- fw-bold fs-2 mb-2 `}>{dashboardData['newlead']}</div>
              </div>
              <div className='row'>
                <div className={`col-lg-8 fw-semibold text-white`}>Expired MemberShip</div>
                <div className={` col-lg-4 text- fw-bold fs-2 mb-2 `}>{dashboardData['newlead']}</div>
              </div>
             
              
            </div>
          </a>
      </div> */}
      {/* <div className='col-xxl-3 col-md-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'white'
          svgIcon= 'save-deposit'
          iconColor= 'primary'
          title= {dashboardData['collected']}
          titleColor= ''
          description= 'Collected'
          descriptionColor= ''
        />
      </div>
      <div className='col-xxl-3 col-md-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'white'
          svgIcon= 'price-tag'
          iconColor= 'info'
          title= {dashboardData['sale']}
          titleColor= ''
          description= 'Sale'
          descriptionColor= ''
        />
      </div> */}
      {/* <div className='col-xxl-3 col-md-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'white'
          svgIcon= 'arrows-loop'
          iconColor= 'success'
          title= {dashboardData['renew_subscription']}
          titleColor= ''
          description= 'Renewed Subscription'
          descriptionColor= ''
        />
      </div> */}

      {/* <div className='col-xxl-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'white'
          svgIcon= 'arrow-mix'
          iconColor= 'warning'
          title= '0'
          titleColor= ''
          description= 'Renewal Follow-up'
          descriptionColor= ''
        />
      </div>
      <div className='col-xxl-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'white'
          svgIcon= 'arrow-up-right'
          iconColor= 'success'
          title= '0'
          titleColor= ''
          description= 'Lead Follow-up'
          descriptionColor= ''
        />
      </div>
      <div className='col-xxl-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'white'
          svgIcon= 'finance-calculator'
          iconColor= ''
          title= '0'
          titleColor= ''
          description= 'Balance Follow-up'
          descriptionColor= ''
        />
      </div>
      <div className='col-xxl-3'>
        <StatisticsWidget5 
          className= 'mb-2'
          color= 'white'
          svgIcon= 'cd'
          iconColor= 'danger'
          title= '0'
          titleColor= ''
          description= 'Non-Live Follow-up'
          descriptionColor= ''
        />
      </div> */}
    </div>

    {/* begin::Row */}
    <div className='row gy-5 g-xl-8 mt-2'>
      {/* <div className='col-xxl-6'>
       <ChartsWidget5 title="Upcoming Payments" className='mb-2'/>
      </div> */}
      {/* <div className='col-xxl-6'>
       <ChartsWidget5 title="Collection vs Expenses" className='mb-2'/>
      </div>
      <div className='col-xxl-6'>
       <ChartsWidget5 title="New Member vs Expired Member" className='mb-2'/>
      </div>
      <div className='col-xxl-6'>
       <ChartsWidget5 title="Collection Mode" className='mb-2'/>
      </div> */}
    </div>
    {/* end::Row */}



  
  </>
);
};

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
